if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));

        // FIX 1: Safari doesn't fire focusout reliably on non-input elements.
        // Use both focusout and a click-outside listener for Safari compatibility.
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this._outsideClickHandler = this.onOutsideClick.bind(this);

        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          // FIX 2: Safari fires 'input' event more reliably than 'keyup' for search fields.
          this.elements.search.addEventListener('input', this.filterCountries.bind(this));
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        // FIX 3: Safari doesn't fire click on <a> tags reliably without cursor:pointer CSS.
        // Adding mousedown as fallback alongside click for Safari.
        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
          item.addEventListener('mousedown', this.onItemMouseDown.bind(this));
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');

        // FIX 4: Safari ignores toggleAttribute('hidden') sometimes.
        // Explicitly set the hidden attribute instead of using toggleAttribute.
        this.elements.panel.setAttribute('hidden', '');

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');

        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.remove('country-selector-open');

        this.header.preventHide = false;

        // FIX 5: Remove outside click listener when panel is hidden.
        document.removeEventListener('click', this._outsideClickHandler);
        document.removeEventListener('touchend', this._outsideClickHandler);
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      // FIX 6: mousedown fires before blur in Safari, so we track if a country
      // link was mousedown'd to prevent the panel closing before click fires.
      onItemMouseDown(event) {
        this._itemMouseDown = true;
        setTimeout(() => { this._itemMouseDown = false; }, 300);
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();

        // FIX 7: Replace toggleAttribute('hidden') with explicit remove for reliability in Safari.
        const isHidden = this.elements.panel.hasAttribute('hidden');
        if (isHidden) {
          this.elements.panel.removeAttribute('hidden');
        } else {
          this.elements.panel.setAttribute('hidden', '');
        }

        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        if (this.elements.search && this.mql.matches) {
          // FIX 8: Safari needs a small delay before focusing an input inside
          // a just-revealed element, otherwise focus silently fails.
          setTimeout(() => { this.elements.search.focus(); }, 50);
        }

        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }

        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.add('country-selector-open');

        // FIX 9: Attach outside click + touchend listener for Safari.
        // Safari doesn't bubble clicks on non-interactive elements reliably.
        setTimeout(() => {
          document.addEventListener('click', this._outsideClickHandler);
          document.addEventListener('touchend', this._outsideClickHandler);
        }, 0);
      }

      // FIX 10: New outside click handler to close panel when clicking outside.
      // This replaces the unreliable focusout-based closing in Safari.
      onOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      }

      closeSelector(event) {
        // FIX 11: Guard against Safari firing focusout when clicking a country link.
        // _itemMouseDown flag prevents premature panel close before click fires.
        if (this._itemMouseDown) return;

        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          // FIX 12: Safari has inconsistent support for \p{Diacritic} with Unicode regex.
          // Use a broader Unicode range replacement as a safer fallback.
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = 0;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', !!searchValue);
        }

        allCountries.forEach((item) => {
          const countrySpan = item.querySelector('.country');
          if (!countrySpan) return;
          const countryName = this.normalizeString(countrySpan.textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const countrySelector = this.querySelector('.country-selector');
        const countrySelectorList = this.querySelector('.country-selector__list');
        if (countrySelector) countrySelector.scrollTop = 0;
        if (countrySelectorList) countrySelectorList.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}